import countriesJson from '$lib/countries.json'
import spainProvinces from '$lib/raw-data/spain-cp-provinces.json'
export const LANGS = {
  es: 'Español',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano'
} as const

export const LANGS_SHORT = Object.keys(LANGS)
export const LANGS_FOR_DROPDOWN = Object.entries(LANGS).map(([value, label]) => ({ value, label }))

export const VALID_PHONE_NUMBER_REGEX = /^$|^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/

export const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/

export const USER_TABS = {
  ACCOUNT: 'account',
  RESERVATIONS: 'reservations',
  INVOICES: 'invoices',
  POINTS: 'points',
  BILLING_ADDRESSES: 'billing_addresses'
} as const

export const ISLANDS = [
  {
    id: 1,
    short: 'GC',
    long: 'Gran Canaria',
    boundingBox: [
      [27.66856, -15.910702],
      [28.220457, -15.289422]
    ]
  },
  {
    id: 2,
    short: 'TF',
    long: 'Tenerife',
    boundingBox: [
      [27.964752, -16.99621],
      [28.635813, -16.048123]
    ]
  },
  {
    id: 3,
    short: 'FV',
    long: 'Fuerteventura',
    boundingBox: [
      [28.00574, -14.595389],
      [28.794003, -13.724673]
    ]
  },
  {
    id: 4,
    short: 'LZ',
    long: 'Lanzarote',
    boundingBox: [
      [28.80817, -14.063028],
      [29.342072, -13.306637]
    ]
  },
  {
    id: 5,
    short: 'LP',
    long: 'La Palma',
    boundingBox: [
      [28.416967, -18.086099],
      [28.879087, -17.690004]
    ]
  },
  {
    id: 156,
    short: 'LG',
    long: 'La Gomera',
    boundingBox: [
      [27.995655, -17.408234],
      [28.225852, -17.071034]
    ]
  },
  {
    id: 157,
    short: 'EH',
    long: 'El Hierro',
    boundingBox: [
      [27.611749, -18.206759],
      [27.879518, -17.818748]
    ]
  }
] as const

export const ISLANDS_LONG = ISLANDS.map((i) => i.long)

export const AIRPORTS_IDS = {
  LPA: 101,
  TFS: 201,
  TFN: 210,
  FUE: 301,
  ACE: 401,
  SPC: 501,
  GMZ: 2556,
  VDE: 2557
}

export const MIN_DAYS_TO_BOOK_SHUTTLE_OUT = 3 //days
export const MIN_DAYS_TO_BOOK = 1 //day

export const SERVICE_TYPES = [
  { id: 1, name: 'Shuttle' },
  { id: 2, name: 'Private' },
  { id: 3, name: 'Discretionary' },
  { id: 4, name: 'Wheelchair' },
  { id: 5, name: 'Excursion' },
  { id: 100, name: 'AtDisposal' },
  { id: 101, name: 'Permanent' }
] as const
export const VEHICLE_TYPES = [
  { id: 6, name: 'car' },
  { id: 7, name: 'luxury' },
  { id: 8, name: 'microbus' },
  { id: 9, name: 'bus' },
  { id: 10, name: 'luxury_minivan' },
  { id: 12, name: 'wheelchair' }
] as const

export const SERVICE_TYPES_IDS = {
  shuttle: 1,
  private: 2,
  discretionary: 3,
  wheelchair: 4,
  excursion: 5,
  atDisposal: 100,
  permanent: 101
} as const

export const IN_OUT = {
  IN: 'In',
  OUT: 'Out',
  OTHER: 'Other'
} as const

export const SERVICE_TYPES_INFO = ['shuttle', 'private', 'premier', 'adapted'] as const

export const SERVICE_TYPES_NAMES = {
  SHUTTLE: 'Shuttle',
  PRIVATE: 'Private',
  PRIVADO: 'Private',
  DISCRETIONARY: 'Discretionary',
  WHEELCHAIR: 'Wheelchair',
  EXCURSION: 'Excursion',
  AT_DISPOSAL: 'AtDisposal',
  A_DISPOSICION: 'Atdisposal',
  PERMANENT: 'Permanent'
} as const
export const NINJA_SERVICE_TYPES_NAMES = {
  SHUTTLE: 'shuttle',
  PRIVATE: 'private',
  DISCRETIONARY: 'discretionary',
  WHEELCHAIR: 'wheelchair',
  EXCURSION: 'excursion',
  AT_DISPOSAL: 'at_disposal',
  ATDISPOSAL: 'atdisposal'
} as const

export const IS_MOBILE_REGEX = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i]

export const TRIP_TYPE = ['one_way', 'round_trip'] as const

export const COMPANY_ADDRESS = 'Movilidad Turística Canaria S.A.U, Calle Adelfas 32,'
export const COMPANY_CP_ADDRESS = 'Las Palmas, España, 35118'
export const COMPANY_CONTACT_PHONES = '+34 928 184 608 / +34 650 617 296'
export const COMPANY_EMAIL = 'reservas.canarias@alsa.es'
export const COMPANY_WEB_LINK = 'www.canaryshuttle.com'

export const PRICES_API_VEHICLES = {
  Bus: 'BUS',
  Car: 'CAR',
  LuxuryCar: 'LUXURY_CAR',
  LuxuryMinivan: 'LUXURY_MINIVAN',
  Minivan: 'MICROBUS',
  WheelChair: 'ADAPTED_VEHICLE',
  // Reverse keys
  BUS: 'BUS',
  CAR: 'CAR',
  LUXURY_CAR: 'LUXURY_CAR',
  LUXURY_MINIVAN: 'LUXURY_MINIVAN',
  MICROBUS: 'MINIVAN',
  ADAPTED_VEHICLE: 'ADAPTED_VEHICLE'
} as const

export const PRICES_TO_NINJA_VEHICLE_TYPES = {
  Bus: 'Bus',
  Car: 'Car',
  LuxuryCar: 'Luxury',
  LuxuryMinivan: 'LuxuryMinivan',
  Minivan: 'Minivan',
  WheelChair: 'WheelChair',
  // Reverse keys
  BUS: 'Bus',
  CAR: 'Car',
  LUXURY_CAR: 'Luxury',
  LUXURY_MINIVAN: 'LuxuryMinivan',
  MINIVAN: 'Minivan',
  MICROBUS: 'Minivan',
  ADAPTED_VEHICLE: 'WheelChair'
} as const

export const PRICES_API_SERVICE_TYPES = {
  Shuttle: 'SHUTTLE',
  Private: 'PRIVADO',
  AtDisposal: 'A_DISPOSICION',
  // Reverse keys
  PRIVADO: 'PRIVADO',
  A_DISPOSICION: 'A_DISPOSICION',
  SHUTTLE: 'SHUTTLE'
} as const

export const PRICES_API_ISLANDS = {
  GC: 'GC',
  TNF: 'TF',
  LP: 'LP',
  FTV: 'FV',
  LNZ: 'LZ',
  LG: 'LG',
  EH: 'EH'
} as const

export const COUNTRIES = countriesJson

export const PAYMENT_METHODS = ['card', 'bizum'] as const
export const TPV_ID = '5' as const
export const ESTIMATES_TPV_ID = '6' as const
export const ACTION_STATUS = {
  SUCCESS: 'true',
  ERROR: 'false',
  WARNING: 'warning'
} as const

export const PATH_COMPANY_LOGO = './static/cs-logo-orange.png'

// PDF TEMPLATES
export const PATH_BILL_TEMPLATE = './src/lib/pdf-templates/bill.html'

export const LUGGAGE_TYPES = ['baby_seats', 'surf', 'golf', 'bike', 'special'] as const

// This is a constant to hide PMRs
export const HIDE_PMRS = true
export const EXCURSION_MODE = {
  HALF_DAY: 'half_day',
  FULL_DAY: 'full_day'
}
export const IN_OUT_TO_PB = {
  In: 'in',
  Out: 'out',
  Other: 'other',
  IN: 'in',
  OUT: 'out',
  OTHER: 'other',
  in: 'in',
  out: 'out',
  other: 'other'
} as const

export const SERVICE_TYPE_TO_PB = {
  Shuttle: 'shuttle',
  Private: 'private',
  Discretionary: 'discretionary',
  Wheelchair: 'wheelchair',
  Excursion: 'excursion',
  AtDisposal: 'at_disposal',
  Permanent: 'permanent',
  SHUTTLE: 'shuttle',
  PRIVATE: 'private',
  PRIVADO: 'private',
  DISCRETIONARY: 'discretionary',
  WHEELCHAIR: 'wheelchair',
  EXCURSION: 'excursion',
  AT_DISPOSAL: 'at_disposal',
  A_DISPOSICION: 'at_disposal',
  PERMANENT: 'permanent',
  shuttle: 'shuttle',
  private: 'private',
  discretionary: 'discretionary',
  wheelchair: 'wheelchair',
  excursion: 'excursion',
  at_disposal: 'at_disposal',
  permanent: 'permanent'
} as const

export const ISLAND_TO_PB = {
  GC: 'Gran Canaria',
  TNF: 'Tenerife',
  LP: 'La Palma',
  FTV: 'Fuerteventura',
  LNZ: 'Lanzarote',
  LG: 'La Gomera',
  EH: 'El Hierro',
  1: 'Gran Canaria',
  2: 'Tenerife',
  5: 'La Palma',
  3: 'Fuerteventura',
  4: 'Lanzarote',
  156: 'La Gomera',
  157: 'El Hierro',
  'Gran Canaria': 'Gran Canaria',
  Tenerife: 'Tenerife',
  'La Palma': 'La Palma',
  Fuerteventura: 'Fuerteventura',
  Lanzarote: 'Lanzarote',
  'La Gomera': 'La Gomera',
  'El Hierro': 'El Hierro'
} as const
export const SHUTTLE_WEB_TEMPLATE_ID = 'd-9f423dbd69db45d28623453a8a409457'

export const LOST_AND_FOUNDS_CATEGORIES = [
  {
    id: 492,
    name: 'accessories_bag_scarf_bracelet_watch_etc',
    subcategories: [
      {
        id: 509,
        name: 'sports_gym_bag'
      },
      {
        id: 510,
        name: 'bag_backpack_shoulder_bag_etc'
      },
      {
        id: 511,
        name: 'bag'
      },
      {
        id: 512,
        name: 'scarf_shawl'
      },
      {
        id: 513,
        name: 'belt'
      },
      {
        id: 514,
        name: 'beanie_cap'
      },
      {
        id: 515,
        name: 'gloves'
      },
      {
        id: 516,
        name: 'briefcase'
      },
      {
        id: 517,
        name: 'lighter'
      },
      {
        id: 518,
        name: 'neckerchief'
      },
      {
        id: 519,
        name: 'umbrella'
      },
      {
        id: 520,
        name: 'bracelet'
      },
      {
        id: 521,
        name: 'watch'
      },
      {
        id: 522,
        name: 'hat'
      },
      {
        id: 523,
        name: 'other_accessories'
      }
    ]
  },
  {
    id: 493,
    name: 'documentation_wallet_id_documents_etc',
    subcategories: [
      {
        id: 524,
        name: 'wallet'
      },
      {
        id: 525,
        name: 'wallet_card_holder'
      },
      {
        id: 526,
        name: 'id_card_credit_card_other_cards'
      },
      {
        id: 527,
        name: 'documents_briefcase'
      },
      {
        id: 528,
        name: 'documentation'
      },
      {
        id: 529,
        name: 'other_documents'
      }
    ]
  },
  {
    id: 494,
    name: 'luggage_suitcase_pushchair_etc'
  },
  {
    id: 495,
    name: 'glasses',
    subcategories: [
      {
        id: 530,
        name: 'sunglasses'
      },
      {
        id: 531,
        name: 'prescription_glasses'
      },
      {
        id: 532,
        name: 'glasses_case'
      }
    ]
  },
  {
    id: 496,
    name: 'photography_equipment_camera_video_recorder_etc',
    subcategories: [
      {
        id: 533,
        name: 'camera'
      },
      {
        id: 534,
        name: 'other_camera_video_recorder_accessories'
      }
    ]
  },
  {
    id: 497,
    name: 'computer_equipment_tablet_laptop_usb_flash_drive_etc',
    subcategories: [
      {
        id: 535,
        name: 'ebook'
      },
      {
        id: 536,
        name: 'laptop'
      },
      {
        id: 537,
        name: 'tablet'
      },
      {
        id: 538,
        name: 'other_computer_equipment'
      }
    ]
  },
  {
    id: 498,
    name: 'jewellery',
    subcategories: [
      {
        id: 539,
        name: 'jewellery_watch'
      },
      {
        id: 540,
        name: 'other_jewellery_items'
      }
    ]
  },
  {
    id: 499,
    name: 'toys_and_sports_items_toys_teddies_balls_etc',
    subcategories: [
      {
        id: 541,
        name: 'toys'
      },
      {
        id: 542,
        name: 'video_game_console'
      }
    ]
  },
  {
    id: 500,
    name: 'books_and_stationary_diary_notes_etc',
    subcategories: [
      {
        id: 543,
        name: 'book'
      },
      {
        id: 544,
        name: 'other_books_and_stationary_items'
      }
    ]
  },
  {
    id: 501,
    name: 'keys'
  },
  {
    id: 502,
    name: 'medicine_medication_etc'
  },
  {
    id: 503,
    name: 'mobile_phone_charger_case_etc',
    subcategories: [
      {
        id: 545,
        name: 'charging_cable'
      },
      {
        id: 546,
        name: 'mobile_phone'
      }
    ]
  },
  {
    id: 504,
    name: 'other_items',
    subcategories: [
      {
        id: 547,
        name: 'other'
      }
    ]
  },
  {
    id: 505,
    name: 'clothing_and_footwear',
    subcategories: [
      {
        id: 548,
        name: 'coat_jacket_duffel_coat_down_jacket_etc'
      },
      {
        id: 549,
        name: 'footwear'
      },
      {
        id: 550,
        name: 'jumper_jacket'
      },
      {
        id: 551,
        name: 'sweatshirt'
      },
      {
        id: 552,
        name: 'other_clothing_and_footwear'
      }
    ]
  },
  {
    id: 506,
    name: 'health_and_beauty_cosmetics_prostheses_etc'
  },
  {
    id: 507,
    name: 'sound_audio_headphones_musical_instrument_etc',
    subcategories: [
      {
        id: 553,
        name: 'earphones_headphones'
      },
      {
        id: 554,
        name: 'musical_instrument'
      },
      {
        id: 555,
        name: 'other_audio_items'
      }
    ]
  },
  {
    id: 508,
    name: 'transport_card',
    subcategories: [
      {
        id: 556,
        name: 'public_transport_card'
      }
    ]
  }
]
export const CP_PROVINCES = spainProvinces
export const COUNTRIES_ARRAY = Object.values(countriesJson)

export const ISLANDS_SHORT_KEY = {
  GC: 'Gran Canaria',
  TF: 'Tenerife',
  LZ: 'Lanzarote',
  FV: 'Fuerteventura',
  LP: 'La Palma'
} as const
export const ISLANDS_LONG_NAME_ARRAY = Object.values(ISLANDS_SHORT_KEY)

export const ISLANDS_NUMERIC_KEY = {
  '1': 'Gran Canaria',
  '2': 'Tenerife',
  '3': 'Fuerteventura',
  '4': 'Lanzarote',
  '5': 'La Palma'
} as const
